// eslint-disable-next-line import/prefer-default-export
import { debugPlayerUrl } from 'BaseConfig/player';
import { CMAF_ID } from '../constants/bcms';

export const convertToInt = variable => {
  if (variable === null) {
    return null;
  }

  return parseInt(variable, 10);
};

export const parseDebugPlayerUrl = response => {
  let debugUrl = response.url.replace(/\\\//g, '/');
  debugUrl = btoa(debugUrl).replace(/\//g, '_').replace(/\+/g, '-');
  debugUrl = debugPlayerUrl.replace(':url', debugUrl).replace(':format', 'DASH');
  if (response.stream_protocol_id === CMAF_ID) {
    debugUrl += '&enableCmaf=true&trackLiveEdge=true';
  }

  return debugUrl;
};
